import { render, staticRenderFns } from "./GoodTable.vue?vue&type=template&id=f62b245a"
import script from "./GoodTable.vue?vue&type=script&lang=js"
export * from "./GoodTable.vue?vue&type=script&lang=js"
import style0 from "./GoodTable.vue?vue&type=style&index=0&id=f62b245a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports